import { render, staticRenderFns } from "./Carte.vue?vue&type=template&id=548b0a85&"
import script from "./Carte.vue?vue&type=script&lang=js&"
export * from "./Carte.vue?vue&type=script&lang=js&"
import style0 from "./Carte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports